<style>
@import '../../custom/css/ver-dica.css';
</style>

<template>
  <div id="ver-cliente" class="ver-dica">
    <div class="form-fields position-relative" v-if="cliente !== null">
      <h1 class="title text-uppercase font-weight-bold">Ver Cliente</h1>
      <hr class="linha-amarela" />
      <div class="row">
        <div class="col-lg-4">
          <div class="form-group">
            <label for="nome">ID</label>
            <div class="text" id="nome">{{ cliente[0].id }}</div>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="form-group">
            <label for="nome">Nome</label>
            <div class="text" id="nome">{{ cliente[0].nome }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="rg">RG</label>
            <div class="text" id="rg">{{ cliente[0].rg }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cpf">CPF</label>
            <div class="text" id="cpf">{{ cliente[0].cpf }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cnpj">CNPJ</label>
            <div class="text" id="cnpj">{{ cliente[0].cnpj }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="telefone">Telefone</label>
            <div class="text" id="telefone">{{ cliente[0].telefone }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="celular">Celular</label>
            <div class="text" id="celular">{{ cliente[0].celular }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cep">CEP</label>
            <div class="text" id="cep">{{ cliente[0].cep }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="endereco">Endereço</label>
            <div class="text" id="endereco">{{ cliente[0].endereco }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="numero">Número</label>
            <div class="text" id="numero">{{ cliente[0].numero }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="complemento">Complemento</label>
            <div class="text" id="complemento">
              {{ cliente[0].complemento }}
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="bairro">Bairro</label>
            <div class="text" id="bairro">{{ cliente[0].bairro }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cidade">Cidade</label>
            <div class="text" id="cidade">{{ cliente[0].cidade }}</div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="estado">Estado</label>
            <div class="text" id="estado">{{ cliente[0].estado }}</div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="criado_em">Criado em</label>
            <div class="text" id="criado_em">{{ cliente[0].criado_em }}</div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="atualizado_em">Atualizado em</label>
            <div class="text" id="atualizado_em">
              {{ cliente[0].atualizado_em }}
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="editarCliente(cliente[0].id)">
          Editar
        </div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse cliente não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ver-cliente',
  data: () => ({
    dados: {},
  }),
  props: ['id'],
  computed: {
    ...mapState({
      cliente: (state) => state.cliente,
    }),
  },
  created() {
    this.$store.dispatch('showCliente', this.id);
  },
  activated() {
    this.$store.dispatch('showCliente', this.id);
  },
  methods: {
    editarCliente(value) {
      this.$router.push({
        name: 'administrador-editar-cliente',
        params: { id: value },
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-clientes',
      });
    },
  },
};
</script>
